<script>
import store from '@state/store'
import { debounce } from 'debounce'
import { format, parseISO } from 'date-fns/fp'
import Layout from '@layouts/loggedin.vue'
import { authComputed } from '@state/helpers'
import AdminTable from '@components/admin-table.vue'
import { ORGANIZATION_SIGNUPS_TABLE_FIELDS } from '@adminOrganizations/constant'
import OrganizationSignupDetails from '@adminOrganizations/components/signup-details.vue'

export default {
  components: {
    Layout,
    AdminTable,
    OrganizationSignupDetails,
  },
  data() {
    return {
      tableFields: ORGANIZATION_SIGNUPS_TABLE_FIELDS,
      selectedSignup: null,
      showDetailsModal: false,
    }
  },
  computed: {
    ...authComputed,
    page() {
      return this.$store.state.adminOrganizations.page
    },
    perPage() {
      return this.$store.state.adminOrganizations.perPage
    },
    lists() {
      return (this.$store.state.adminOrganizations.lists || []).map((item) => ({
        ...item,
        createdAt: item.created_at
          ? format('M/d/yy', parseISO(item.created_at))
          : '',
      }))
    },
    total() {
      return this.$store.state.adminOrganizations.total
    },
    loaded() {
      return this.$store.state.adminOrganizations.loaded
    },
    hasNoData() {
      return !this.lists.length && this.loaded
    },
    loading() {
      return !this.lists.length && !this.loaded
    },
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      store.dispatch('adminOrganizations/fetchLists').catch((err) => {
        alert(err.message || 'Failed to load organization signups.')
      })
    },
    setPage: debounce(async function setPage({ page, perPage }) {
      store
        .dispatch('adminOrganizations/setPage', { page, perPage })
        .catch((err) => {
          alert(err.message || 'Something went wrong.')
        })
    }, 300),
    setFilterParams: debounce(async function setFilterParams(params) {
      store
        .dispatch('adminOrganizations/setFilterParams', params)
        .catch((err) => {
          alert(err.message || 'Something went wrong.')
        })
    }, 500),
    setSortParams(params) {
      store
        .dispatch('adminOrganizations/setSortParams', params)
        .catch((err) => {
          alert(err.message || 'Something went wrong.')
        })
    },
    viewDetails(item) {
      this.selectedSignup = item
      this.showDetailsModal = true
    },
    closeDetailsModal() {
      this.showDetailsModal = false
      this.selectedSignup = null
    },
    async updateStatus(id, status) {
      try {
        await store.dispatch('adminOrganizations/updateItemStatus', {
          id,
          status,
        })
        alert(`Organization signup ${status} successfully`)
        this.fetchData()
        this.closeDetailsModal()
      } catch (err) {
        alert(err.message || 'Failed to update status')
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bg-white py-20 px-8 mx-7.5 rounded-xl shadow-lg min-h-32">
      <h1 class="text-3xl text-blue-darker mb-8 font-bold">
        Organization Signups
      </h1>
      <AdminTable
        table-type="ORGANIZATION_SIGNUPS"
        :table-fields="tableFields"
        :no-new-btn="true"
        :total-num="total"
        :list-data="lists"
        :data-loaded="loaded"
        :cur-page="page"
        :per-page="perPage"
        @table-set-sort-params="setSortParams"
        @table-set-filter-params="setFilterParams"
        @table-go-edit-item="viewDetails"
        @table-set-page="setPage"
      />
    </div>

    <OrganizationSignupDetails
      v-if="showDetailsModal"
      :signup="selectedSignup"
      @close="closeDetailsModal"
      @update-status="updateStatus"
    />
  </Layout>
</template>
